module.exports = __webpack_public_path__ + "img/icon-folder.884840ef.svg";